<div class="content">
  <h5>{{ 'train.journey-info' | translate }}</h5>
  <div class="date">
    <p>{{ train.departDate | date:'dd/MM HH:mm' }}</p>
    <img src="assets/img/svg/arrow-right.svg" alt="" />
    <p>{{ train.arriveDate | date:'dd/MM HH:mm' }}</p>
  </div>
  <div class="journey">
    <div *ngFor="let section of train.sections; let i = index">
      <div class="wait-duration" *ngIf="i !== 0">
        <span>{{'train.transfer-time' | translate}}: </span>
        <span>{{getWaitDuration(i-1)}}</span>
      </div>
      <div class="section">
        <div class="time-line">
          <div class="dot"></div>
          <div class="line"></div>
          <div class="dot"></div>
        </div>
        <div class="section-container">
          <div class="origin">
            <span>{{ section.departDate | date:'HH:mm' }}</span>
            <span>{{ section.origin }}</span>
          </div>
          <div class="duration">
            <span>{{ trainService.getDuration(section) }}</span>
            <span>{{ section.trainNumber }}</span>
            <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="" />
          </div>
          <div class="origin">
            <span>{{ section.arriveDate | date:'HH:mm' }}</span>
            <span>{{ section.destination }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>